import { BadgeM } from "@common/components/badge/BadgeM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { LinearGradient } from "expo-linear-gradient"
import React, { useContext } from "react"
import { View } from "react-native"
import { ActivityIndicator, Tooltip } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

export const withTooltip = (tooltipTitle, Component) => {
    if (tooltipTitle) {
        return (
            <Tooltip
                title={tooltipTitle}
                leaveTouchDelay={500}
                titleMaxFontSizeMultiplier={0.5}
            >
                {Component}
            </Tooltip>
        )
    }
    return Component
}
export const IconTouchableRipple = ({
    icon,
    iconSize = null,
    onPress,
    label,
    badgeCounter,
    tooltipTitle = null,
    style,
    disabled = false,
    color = theme.colors.greyAlt,
    horizontal = false,
    fontSize = null,
    backgroundColor = null,
    loading = false,
}) => {
    const dimensions = useContext(DimensionsContext)
    const isRobotIcon = icon === "robot"

    const iconComponent = (
        <View
            style={{
                flex: !label ? 1 : null,
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
            }}
        >
            <FontAwesome5
                size={iconSize ?? 14}
                solid
                name={icon}
                style={{
                    margin: 10,
                    zIndex: 4,
                    height: iconSize ?? 14,
                }}
                color={color}
            />
        </View>
    )

    const iconContainer = isRobotIcon ? (
        <View
            style={{
                position: "relative",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
            }}
        >
            <LinearGradient
                colors={[theme.colors.sam, backgroundColor]} // Purple to Royal Blue gradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    borderRadius: 13,
                    opacity: 0.7,
                    zIndex: 0,
                }}
            />
            {iconComponent}
        </View>
    ) : (
        iconComponent
    )

    if (loading) {
        return (
            <View
                style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    alignSelf: "center",
                }}
            >
                <ActivityIndicator size="small" color={color} />
            </View>
        )
    }

    return withTooltip(
        tooltipTitle,
        <TouchableRippleM
            style={{
                alignItems: dimensions.width > 800 ? "center" : "flex-start",
                flex: 1,
                cursor: disabled ? null : "pointer",
                ...style,
            }}
            disabled={disabled}
            onPress={onPress}
        >
            <View
                style={{
                    flex: 1,
                    flexDirection: horizontal ? "row" : "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                }}
            >
                {iconContainer}
                {!!label && (
                    <TextM
                        style={{
                            marginTop: horizontal ? 0 : -6,
                            textAlign: "center",
                        }}
                        fontSize={fontSize ? fontSize : IS_WEB ? 16 : 12}
                        fontWeight={"Regular"}
                        color={color}
                        wrap
                    >
                        {label}
                    </TextM>
                )}
                {badgeCounter > 0 && (
                    <BadgeM
                        count={badgeCounter}
                        style={{
                            backgroundColor: theme.colors.error,
                            color: theme.colors.white,
                            position: "absolute",
                            top: -5,
                            right: -5,
                        }}
                    />
                )}
            </View>
        </TouchableRippleM>
    )
}
